/* eslint-disable no-unused-vars */
import React, { useState } from 'react'
import { Container } from 'react-bootstrap'
import PropTypes from 'prop-types'
import MyImage from '@shared/components/myImage'
import { getImgURL } from '@shared-submodule/utils'
import { BLUR_DATA_URL_BASE64 } from '@shared-submodule/sm-constants'
import ShortsSlider from '../shortsSlider'
import ShortsDetail from '../shortsDetail'
import styles from './style.module.scss'
import { PlayIcon } from '@shared/components/ctIcons'
import noImage from '@assets/images/placeholder/videos-shorts.jpg'

const Shorts = ({ video }) => {
  const [showModal, setShowModal] = useState(false)
  const [vidNumber, setVidNumber] = useState(-1)

  const openModal = () => {
    setShowModal(true)
  }

  const closeModal = () => {
    setShowModal(false)
  }

  return (
    <Container className={`${styles.shorts}`}>
      <div className='container'>
        <h4 className={styles.heading}>Cricket Shorts & Stories</h4>
      </div>
      <div className={`${styles.sliderContainer} container`}>
        <ShortsSlider nav gap={25} destroyBelow={1199}>
          {video?.map((item, index) => (
            <div key={item._id} className={styles.sliderItem} onClick={() => { setVidNumber(index); openModal() }}>
              <PlayIcon />
              <MyImage
                src={getImgURL(item.aThumbnails[3].sUrl) || getImgURL(item.sThumbnailUrl) || noImage}
                alt={item.sTitle}
                blurDataURL={BLUR_DATA_URL_BASE64}
                placeholder='blur'
                height={120}
                width={320}
                layout='responsive'
                sizes='(max-width: 767px) 120px, (max-width: 991px) 180px, (max-width: 1190px) 200px, 240px'
              />
              <div className={styles.titleContainer}>
                <div className={styles.titleBackground} />
                <div className={styles.titleContent}>
                  <a className={styles.title}>{item.sTitle}</a>
                </div>
              </div>
            </div>
          ))}
        </ShortsSlider>
        {
          showModal && (
            <ShortsDetail isOpen={showModal} onClose={closeModal} data={video} vidNumber={vidNumber} />
          )
        }
      </div>
    </Container>
  )
}

Shorts.propTypes = {
  video: PropTypes.array
}

export default Shorts
